<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div
              class="card-header border-bottom p-1 d-flex justify-content-start flex-wrap"
            >
              <div
                class="m-1"
                role="group"
                data-toggle="buttons"
                v-for="master in masters"
              >
                <button
                  class="btn btn-primary font-weight-bold border btn-outline-primary h5 mb-0 p-1 pl-3 pr-3"
                  :class="{
                    active: selectedView === master,
                    border: selectedView === master
                  }"
                  @click.prevent="selectedView = master"
                  type="button"
                >
                  {{ master.name }}
                </button>
              </div>
              <button
                class="btn btn-primary font-weight-bold border btn-outline-primary h5 mb-0 p-1 pl-3 pr-3 m-1"
                :class="{
                  active: selectedView === 'variables',
                  border: selectedView === 'variables'
                }"
                type="button"
                @click.prevent="selectedView = 'variables'"
              >
                Variables
              </button>
            </div>
            <div class="card-body">
              <master-list
                v-if="selectedView !== 'variables'"
                :typeMaster="selectedView"
              />
              <variables v-if="selectedView === 'variables'" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterList from './MasterList.vue'
import Variables from './Variables.vue'
export default {
  components: {
    MasterList,
    Variables
  },
  data() {
    return {
      buttonApplicationLetterUrl: 'SettingsApplicationLetter',

      selectedView: {},
      masters: [
        {
          id: 1,
          name: 'Tipo de empresa',
          url_api: 'type_company'
        },
        {
          id: 2,
          name: 'Tipo de cobro',
          url_api: 'type_payment'
        },
        {
          id: 3,
          name: 'Tipo de Banco',
          url_api: 'type_bank'
        },
        {
          id: 4,
          name: 'Moneda',
          url_api: 'type_currency'
        },
        {
          id: 5,
          name: 'Estado de usuario',
          url_api: 'type_user_status'
        },
        {
          id: 6,
          name: 'Estado de pago',
          url_api: 'type_payment_status'
        },

        /*

        {
          id: 7,
          name: 'Estado de promoción',
          url_api: 'type_promotion_status'
        },

        */

        {
          id: 8,
          name: 'Modo de cobro',
          url_api: 'type_payment_mode'
        },
        /*

        {
          id: 9,
          name: 'Estado de noticia',
          url_api: 'type_new_status'
        },

        */
        /*

        {
          id: 10,
          name: 'Estado de evento',
          url_api: 'type_event_status'
        },

        */

        {
          id: 11,
          name: 'Tipo de servicio',
          url_api: 'type_service'
        }
      ]
    }
  },
  methods: {
    goApplicationLetter() {
      this.$router.push({ name: this.buttonApplicationLetterUrl })
    }
  },
  mounted() {
    this.selectedView = this.masters[0]
  }
}
</script>

<style>
.text-title-dashboard {
  color: #30476c;
}
tr:last-child td {
  border-bottom: 1px solid #dee2e6; /* Asegúrate de que la última fila tenga un borde inferior */
}
.btn-settings {
  background-color: #2f4a93;
  color: white;
  border-radius: 12px;
  height: 90px;
  border: none;
  font-size: 20px;
}
.btn-settings:hover {
  background-color: #0d2a57;
}
</style>
